import { type OrderApprovalCountsConstructor } from '@webapp/modules/purchasing/entities/OrderApprovalCounts'
import { type OrderApprovalCountsApiModel } from '../api-models/OrderApprovalCountsApiModel'

export const mapOrderApprovalCountsApiModel = (
  raw: OrderApprovalCountsApiModel
): OrderApprovalCountsConstructor => ({
  all: raw.all,
  pending: raw.pending,
  approved: raw.approved,
  denied: raw.denied,
})
